function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st001{fill:url(#SVGID_100_);}\n\t.st100{fill:#F7931E;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st001",
  d: "M16,24H8c-4.4,0-8-3.6-8-8V8c0-4.4,3.6-8,8-8h8c4.4,0,8,3.6,8,8v8C24,20.4,20.4,24,16,24z M8,1 C4.1,1,1,4.1,1,8v8c0,3.9,3.1,7,7,7h8c3.9,0,7-3.1,7-7V8c0-3.9-3.1-7-7-7H8z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-28",
  transform: "translate(6.000129, 5.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("path", {
  className: "st100",
  d: "M6,0c1.7,0,3,1.3,3,3S7.7,6,6,6S3,4.7,3,3S4.3,0,6,0z M6,2C5.4,2,5,2.4,5,3s0.4,1,1,1s1-0.4,1-1S6.6,2,6,2z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Pathy"
}, /*#__PURE__*/React.createElement("path", {
  className: "st100",
  d: "M6,7c3,0,5.4,2.1,6,5c-1.7,1.3-3.7,2-6,2c-2.3,0-4.3-0.8-6-2C0.6,9.1,3,7,6,7z M6,9c-1.5,0-2.8,0.8-3.5,2.1 l0,0.1l0.2,0.1c1,0.5,2,0.7,3.1,0.8L6,12c1.2,0,2.4-0.3,3.4-0.8l0.2-0.1l0-0.1c-0.7-1.2-1.9-2-3.3-2L6,9z"
}))));

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: -465.0652,
    y1: 491.3261,
    x2: -465.5869,
    y2: 491.3261,
    gradientTransform: "matrix(23 0 0 -23 10714.5 11312.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAB535"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F7931E"
    }
  })), _ref3)), _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.04bf20ae.svg";
export { ForwardRef as ReactComponent };